import { Directive, ElementRef, inject, input, OnInit, Renderer2 } from '@angular/core';
import { StopKind } from '@/common/enums/BagTransport';
import { StopKindColor } from '@/new-transport/_models/transport-timetable.model';

@Directive({
	selector: '[appBoardingStatus]',
	standalone: true,
})
export class BoardingStatusDirective implements OnInit {
	appBoardingStatus = input.required<StopKind[]>();
	locationName = input.required<string>();

	private readonly el = inject(ElementRef);
	private readonly renderer = inject(Renderer2);

	ngOnInit(): void {
		let styleValue = '';
		let icon = '';

		switch (true) {
			case this.isContainsStopKind(StopKind.BOARDING) && this.isContainsStopKind(StopKind.DROP_OFF):
				styleValue = StopKindColor.ADVANCED;
				icon = 'fas fa-question-circle';
				break;
			case this.isContainsStopKind(StopKind.BOARDING):
				styleValue = StopKindColor.BOARDING;
				icon = 'fas fa-arrow-circle-right';
				break;
			case this.isContainsStopKind(StopKind.DROP_OFF):
				styleValue = StopKindColor.DROP_OFF;
				icon = 'fas fa-arrow-circle-left';
				break;
			case this.isContainsStopKind(StopKind.CRUISING):
				styleValue = StopKindColor.CRUISING;
				icon = 'fas fa-dot-circle';
				break;
			case this.isContainsStopKind(StopKind.TARGET):
				styleValue = StopKindColor.TARGET;
				icon = 'fas fa-suitcase-rolling';
				break;
			default:
				styleValue = '';
				icon = '';
				break;
		}

		if (styleValue) {
			this.renderer.setStyle(this.el.nativeElement, 'border-left', `5px ${styleValue} solid`);
			this.renderer.addClass(this.el.nativeElement, 'px-2');
			this.renderer.addClass(this.el.nativeElement, 'py-1');
		}

		this.renderer.setProperty(this.el.nativeElement, 'textContent', '');

		const textNode = this.renderer.createText(this.locationName());
		this.renderer.appendChild(this.el.nativeElement, textNode);

		if (icon) {
			const iconElement = this.renderer.createElement('i');
			const iconClasses = icon.split(' ');

			iconClasses.forEach((iconClass) => {
				this.renderer.addClass(iconElement, iconClass);
			});

			this.renderer.addClass(iconElement, 'ps-1');
			this.renderer.setStyle(iconElement, 'color', styleValue);

			this.renderer.appendChild(this.el.nativeElement, iconElement);
		}
	}

	private isContainsStopKind(stopKind: StopKind): boolean {
		return this.appBoardingStatus().includes(stopKind);
	}
}
